import type { CreateCustomerResponse, CreateCustomerRequestPayload } from '@vy/api-definition';
import { CreateCustomerResponseSchema } from '@vy/api-definition';
import type { VyCustomerConflictError } from '@vy/error';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useCreateCustomer(
  options?: UseMutationOptions<CreateCustomerResponse, VyCustomerConflictError, CreateCustomerRequestPayload>,
) {
  return useMutation({
    mutationFn: async (createCustomerRequest) => {
      const api = getPrivateApi();
      const createCustomerResponse = await api.createCustomer({
        createCustomerRequest,
      });

      return CreateCustomerResponseSchema.parse(createCustomerResponse);
    },
    ...options,
  });
}
